import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import EnExportIcon from 'Components/icons/EnExportIcon.vue';
import { EnItem } from 'Components/base/EnItem';
import { useNotificationType } from '../../notifications/composables/useNotificationType';
import { X } from 'lucide-vue-next';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnNotificationPushItem',
    props: {
        /**
         * Message to be shown
         */
        item: Object,
        /**
         * If true, x (close) button appears in the top-right corner
         */
        canBeRead: {
            type: Boolean,
            default: true
        }
    },
    emits: ['on:notification:read'],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        // Compute the appropriate icon based on the notification type
        const { notificationType, icon } = useNotificationType(props.item?.type);
        function closeNotification() {
            emit('on:notification:read', props.item);
        }
        const __returned__ = { t, props, emit, notificationType, icon, closeNotification, EnExportIcon, get EnItem() { return EnItem; }, get X() { return X; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
